import { computed, ref, unref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import logoZH from '@/assets/images/influenbase-logo-zh.png'
import logoEN from '@/assets/images/influenbase-logo-en.png'
import footerLogoEN from '@/assets/images/influenbase-footer-logo-en.png'
import footerLogoZH from '@/assets/images/influenbase-footer-logo-zh.png'
import toolEN from '@/assets/images/influenbase-contact-tool-en.png'
import toolZH from '@/assets/images/influenbase-contact-tool-zh.png'
import { getConfig } from '@/utils/index'

export function useGetLanguage() {
  const { locale, t } = useI18n()

  // 插件跳转下载地址
  let urlEN =
    'https://chromewebstore.google.com/detail/influenbase/kfipgmkhiodjpmannnmggccbeafcfldl?hl=EN'
  let urlCN = `https://chromewebstore.google.com/detail/influenbase/kfipgmkhiodjpmannnmggccbeafcfldl?hl=zh-CN`
  const extensionUrl = ref(locale.value === 'zh' ? urlCN : urlEN)

  // 联系二维码
  const contactUrl = ref(
    locale.value === 'zh'
      ? getConfig('bp_landing_page_contact_zh')
      : getConfig('bp_landing_page_contact_us'),
  )

  // 隐私政策
  const privacyPolicyUrl = ref(
    locale.value === 'zh'
      ? getConfig('bp_landing_page_privacy_policy_zh')
      : getConfig('bp_landing_page_privacy_policy_us'),
  )
  // 帮助文档
  const helpDocUrl = ref(
    locale.value === 'zh' ? getConfig('bp_landing_sys_faq_zh') : getConfig('bp_landing_sys_faq_us'),
  )
  // 应用介绍链接
  const appIntroductionUrl = ref(
    locale.value === 'zh'
      ? getConfig('bp_landing_page_plugin_intro_zh_url')
      : getConfig('bp_landing_page_plugin_intro_en_url'),
  )
  // h5直接联系地址
  const contactAddress = ref(
    locale.value === 'zh'
      ? getConfig('bp_landing_sys_mobile_contact_zh')
      : getConfig('bp_landing_sys_mobile_contact_us'),
  )

  // 案例相关文案
  const caseText: any = computed(() => {
    let text: any = {
      zh: {
        text1: 'Psylos1 —— 原创潮牌出海北美',
        text2: 'Psylos1，中国原创潮牌，进军北美市场。',
        text3: '如何快速找到合适的海外达人，提升品牌销量与影响力。',
        text4: [
          '借助 <span>AI 智能筛选</span> ，迅速锁定北美时尚与鞋类领域高契合达人',
          '通过 <span>一键建联</span>  功能，节省 70% 外联时间，加速合作落地',
          '批量导出达人数据，快速形成营销矩阵',
        ],
        text5: [
          'TikTok 美区鞋类销量 <span>半个月冲到第 2 名</span>',
          '达人合作推动 GMV 月增长 <span>890%</span>',
          '配合 Meta 投放，ROI 最高超过<span>1:41</span>',
        ],
        text6: 'WaterH —— 智能水杯全球销量破百万',
        text7: 'WaterH，深圳智能水杯品牌，从代工厂转型自有品牌。',
        text8: '缺乏品牌背书，难以突破初始流量瓶颈。',
        text9: [
          '通过 <span>达人数据库</span> 快速找到 3000+ 优质达人，其中 800+ 粉丝超 10 万',
          '借助 <span>相似达人扩展</span> 功能，持续扩大合作规模',
          '使用 <span>外联自动化</span> ，大幅减少沟通成本，形成稳定的达人关系网',
        ],
        text10: [
          '全渠道累计 GMV 超过 <span> $6,000,000</span>，订单突破 <span>100,000+</span>',
          '单个达人单日最高出单 <span>1900+</span> ',
          'TikTok 曝光量突破 <span>1 亿</span> ，带动亚马逊 & 独立站销量同步增长',
        ],
        text11: 'Lord & Berry —— 意大利彩妆的 TikTok 爆品',
        text12: 'Lord & Berry，意大利米兰专业彩妆品牌。',
        text13: '进入美区市场，如何高效打造爆款声量与销量。',
        text14: [
          '通过 <span>AI 匹配</span> ，锁定 700+ 精选垂类达人，其中 60% 粉丝数超 10 万',
          '<span>批量外联</span>与<span>数据分析</span>  帮助团队精准选择高 ROI 达人',
          '<span>内容追踪与迭代</span>，支持在短时间内集中孵化爆款 SKU 内容',
        ],
        text15: [
          '项目 30 天 GMV 增长 <span>1480%</span>',
          '防水睫毛膏 20 天 <span>卖断货</span>',
          'TikTok 曝光量超 <span>500 万</span>，单 SKU 集中产出<span>300+</span>条带货内容',
        ],
        text16: 'Snaplii —— FinTech 应用增长',
        text17: 'Snaplii，北美数字钱包应用。',
        text18: 'FinTech 应用获客成本高，平均 CPI 达 $8.70。',
        text19: [
          '<span>精准匹配</span>200+ 高互动达人',
          '支持<span>跨团队</span>批量外联与追踪',
          '结合数据优化，找到<span>低成本获客</span>路径',
        ],
        text20: [
          '3 个月新增下载 <span>12,000+</span>，CPI 仅 <span>$2.88</span>（行业均值 -67%）',
          '246 条视频，6.6M+ 定向曝光，单条视频最高播放 <span>156 万</span>',
        ],
        text21: 'Alibaba —— B2B 电商平台曝光',
        text22: 'Alibaba.com，美国市场推广。',
        text23: '在竞争激烈的 B2B 环境中，需快速提升曝光并降低流量成本。',
        text24: [
          '精准锁定美国 <span>B2B</span> 垂类达人',
          '支持<span>大规模</span> 外联与投放组合',
          '<span>数据分析</span>保障流量转化效率',
        ],
        text25: [
          '7 天内实现 <span>150 万+ 曝光</span>',
          '获得<span>28,000+</span>点击，平均 CPC 仅<span>$0.12</span>（远低于目标 $0.60）',
        ],
        text26: 'RéVive —— 高端护肤品牌的增长实践',
        text27: 'RéVive，美国高端护肤品牌，官网 reviveskincare.com。',
        text28: '高端护肤品新客获取遇到瓶颈，需平衡品牌调性与转化。',
        text29: [
          '借助<span>AI 智能筛选</span>快速锁定美妆/护肤垂类达人',
          '<span>一键建联</span>实现高效沟通，缩短达人合作周期',
          '<span>数据驱动投放</span>：结合达人视频和广告测试，高效放大优质素材',
        ],
        text30: [
          '合作达人 100+，累计视频 120+，转化订单<span>127+</span>',
          '广告投放总花费<span>$510.99</span> ，带来销售额 <span>$44,373.70，ROAS高达80+</span>',
          '单条达人视频最高转化额 <span>$13,514.61</span>，广告 ROAS 最高 <span>330+</span>',
          '邮件新增用户 2363+，新客环比增长 <span>929%</span>',
        ],
        text31: 'D-POW —— 银饰品牌的 TikTok 爆发式增长',
        text32: 'D-POW 是一家专注银饰品的时尚品牌，以极简设计与工艺打磨受到年轻消费者喜爱。',
        text33:
          '作为 TikTok 新店铺，D-POW 面临 从零起步 的难题，需要快速在细分类目中打开销量与排名。',
        text34: [
          '<span>达人快速建联</span>：通过 Influenbase，团队在开店初期迅速锁定并对接银饰类相关达人，减少冷启动时间。',
          '<span>数据驱动优化</span>：结合 Influenbase 的达人表现数据，集中资源在高转化达人上，提升 ROI',
          '<span>类目渗透</span>：通过达人矩阵内容覆盖，推动店铺在细分类目中快速攀升',
        ],
        text35: [
          '开店首月（7.16 起），店铺即冲上 TikTok <span>银饰项链类目第 1 名</span>',
          '同期，银饰整体大类目排名进入 <span>第 6 名</span> ',
          '仅用一个月时间，在 TikTok 银饰赛道中快速实现<span>爆发式突破</span>',
        ],
      },
      en: {
        text1: 'Psylos1 — Original Streetwear Brand Expanding to North America',
        text2: 'Psylos1, a Chinese original streetwear brand, entering the North American market.',
        text3:
          'How to quickly find the right overseas influencers and boost brand sales and awareness.',
        text4: [
          'With <span>AI-powered screening</span>, rapidly identified highly relevant influencers in North American fashion and footwear',
          'Used <span>one-click outreach</span> to save 70% of outreach time and accelerate collaborations',
          'Exported influencer data in bulk to quickly build a marketing matrix',
        ],
        text5: [
          'TikTok US footwear sales hit <span>#2 in just two weeks</span>',
          'Influencer collaborations drove monthly GMV growth of <span>890%</span>',
          'Combined with Meta ads, ROI peaked at <span>1:41</span>',
        ],
        text6: 'WaterH — Smart Water Bottle Brand Exceeding 1M Global Sales',
        text7:
          'WaterH, a Shenzhen-based smart water bottle brand, transformed from OEM to owned brand.',
        text8:
          'Faced lack of brand credibility and struggled to break the initial traffic bottleneck.',
        text9: [
          'With the <span>influencer database</span>, quickly found 3000+ quality influencers, including 800+ with over 100K followers',
          'Leveraged <span>lookalike influencer expansion</span> to continuously scale collaborations',
          'Used <span>automated outreach</span> to cut communication costs and form a stable influencer network',
        ],
        text10: [
          'Omnichannel GMV exceeded <span>$6,000,000</span>, with 100,000+ orders',
          'Single influencer drove up to <span>1900+ orders in one day</span>',
          'TikTok views surpassed <span>100M</span>, boosting sales on Amazon & DTC store',
        ],
        text11: "Lord & Berry — Italian Beauty Brand's TikTok Breakthrough",
        text12: 'Lord & Berry, professional cosmetics brand from Milan, Italy.',
        text13:
          'Expanding into the US market, needing efficient ways to create viral products and drive sales.',
        text14: [
          'With <span>AI matching</span>, locked onto 700+ niche influencers, 60% with over 100K followers',
          '<span>Bulk outreach</span> and <span>data analytics</span> helped the team precisely select high-ROI influencers',
          '<span>Content tracking and iteration</span> enabled fast incubation of viral SKU content',
        ],
        text15: [
          'GMV grew <span>1480%</span> in 30 days',
          'Waterproof mascara sold out in <span>20 days</span>',
          'TikTok exposure hit <span>5M+</span>, with 300+ influencer-driven content pieces for a single SKU',
        ],
        text16: 'Snaplii — FinTech App Growth',
        text17: 'Snaplii, a North American digital wallet app.',
        text18: 'High FinTech user acquisition costs, with average CPI at $8.70.',
        text19: [
          '<span>Precisely matched</span> 200+ high-engagement influencers',
          'Supported <span>cross-team</span> bulk outreach and tracking',
          'Optimized with data insights to find <span>lower-cost acquisition</span> paths',
        ],
        text20: [
          'Added <span>12,000+</span> new downloads in 3 months, CPI only <span>$2.88</span> (67% below industry average)',
          '246 videos delivered 6.6M+ targeted impressions, with a single video hitting <span>1.56M views</span>',
        ],
        text21: 'Alibaba — B2B Platform Exposure',
        text22: 'Alibaba.com, US market campaign.',
        text23:
          'In a competitive B2B environment, needed to quickly boost exposure while lowering traffic costs.',
        text24: [
          'Precisely targeted US <span>B2B</span> niche influencers',
          'Enabled <span>large-scale</span> outreach and ad placement',
          '<span>Data analytics</span> ensured efficient traffic conversion',
        ],
        text25: [
          'Generated <span>1.5M+ impressions</span> in 7 days',
          'Achieved <span>28,000+</span> clicks with average CPC only <span>$0.12</span> (far below $0.60 goal)',
        ],
        text26: 'RéVive — Growth of a Premium Skincare Brand',
        text27: 'RéVive, US luxury skincare brand (reviveskincare.com).',
        text28:
          'Faced challenges in acquiring new customers while balancing brand image with conversions.',
        text29: [
          'Used <span>AI-powered screening</span> to quickly identify beauty/skincare niche influencers',
          '<span>One-click outreach</span> enabled efficient communication and shortened collaboration cycles',
          '<span>Data-driven campaigns</span>: combined influencer content with ad testing to scale top-performing creatives',
        ],
        text30: [
          'Worked with 100+ influencers, generating 120+ videos and <span>127+ conversion orders</span>',
          'Ad spend totaled <span>$510.99</span> and drove <span>$44,373.70 in sales</span>, with ROAS over 80+',
          'Single influencer video delivered <span>$13,514.61 in sales</span>, with peak ad ROAS of <span>330+</span>',
          'Added 2363+ email subscribers, new users grew <span>929% MoM</span>',
        ],
        text31: 'D-POW — Explosive Growth of a Silver Jewelry Brand on TikTok',
        text32:
          'D-POW is a fashion silver jewelry brand known for minimalist design and craftsmanship, popular among young consumers.',
        text33:
          'As a new TikTok shop, D-POW needed to quickly break into the niche category and scale rankings from zero.',
        text34: [
          '<span>Fast influencer connections</span>: with Influenbase, the team quickly identified and connected with silver jewelry influencers during launch, reducing cold-start time.',
          '<span>Data-driven optimization</span>: leveraged influencer performance data to focus resources on high-conversion influencers, improving ROI.',
          '<span>Category penetration</span>: through influencer matrix content, the shop rapidly climbed rankings in the niche category.',
        ],
        text35: [
          'Within the first month (from July 16), the shop hit <span>#1 in TikTok’s silver necklace category</span>',
          'At the same time, silver jewelry overall category ranking rose to <span>#6</span>',
          'In just one month, achieved <span>explosive breakthrough</span> in the TikTok silver jewelry niche',
        ],
      },
    }
    return text[locale.value]
  })

  // logo
  const logo = computed(() => {
    return locale.value === 'en' ? logoEN : logoZH
  })

  // footer logo
  const footerLogo = computed(() => {
    return locale.value === 'en' ? footerLogoEN : footerLogoZH
  })

  // tool
  const toolImg = computed(() => {
    return locale.value === 'en' ? toolEN : toolZH
  })

  // copy text
  const copyText = computed(() => {
    return t('system.text2')
  })

  return {
    extensionUrl,
    contactUrl,
    privacyPolicyUrl,
    helpDocUrl,
    appIntroductionUrl,
    contactAddress,
    language: locale,
    caseText: unref(caseText),
    logo,
    footerLogo,
    toolImg,
    copyText,
  }
}
